import { all } from 'redux-saga/effects';
import { recipeSagas } from 'src/state/recipe/sagas';


export default function* rootSaga(): IterableIterator<any> {
  yield all([
    ...recipeSagas
  ])
}